import React, { Component } from 'react'
import Dropdown from './Dropdown'
import FieldTypes from './FieldTypes'
import Radiolist from './Radiolist'

export default class InputField extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fieldModel: null
        }
    }

    componentDidMount() {
        this.setState({
            fieldModel: this.props.fieldModel
        })
    }

    generateInputFieldByType = () => {
        const { fieldModel } = this.state
        const { value, fieldEvents } = this.props

        switch (fieldModel.type) {
            case FieldTypes.alpha:
                return (
                    <input
                        id={fieldModel.id}
                        value={value}
                        name={fieldModel.name}
                        onChange={fieldEvents.onChange}
                        className='value'
                        type='text'
                        fieldtype={FieldTypes.alpha}
                    />
                )
            case FieldTypes.alphanumeric:
                return (
                    <input
                        id={fieldModel.id}
                        value={value}
                        name={fieldModel.name}
                        onChange={fieldEvents.onChange}
                        className='value'
                        type='text'
                        fieldtype={FieldTypes.alphanumeric}
                    />
                )
            case FieldTypes.email:
                return (
                    <input
                        id={fieldModel.id}
                        value={value}
                        name={fieldModel.name}
                        onChange={fieldEvents.onChange}
                        className='value'
                        type='email'
                        fieldtype={FieldTypes.email}
                    />
                )
            case FieldTypes.number:
                return (
                    <input
                        id={fieldModel.id}
                        value={value}
                        name={fieldModel.name}
                        onChange={fieldEvents.onChange}
                        className='value'
                        type='number'
                        fieldtype={FieldTypes.number}
                    />
                )
            case FieldTypes.singleImage:
                return (
                    <input
                        id={fieldModel.id}
                        onChange={fieldEvents.onChange}
                        value={value}
                        className='value fileupload'
                        type="file"
                        fieldtype={FieldTypes.singleImage}
                    />
                )
            case FieldTypes.dropdown:
                return (
                    <Dropdown model={fieldModel} events={fieldEvents} value={value} />
                )
            case FieldTypes.radiolist:
                return (
                    <Radiolist model={fieldModel} events={fieldEvents} value={value} />
                )
            default: return null
        }
    }

    render() {
        const { fieldModel } = this.state

        if (!fieldModel)
            return null;

        return (
            <div className="field">
                <div className="key">{fieldModel.label || ''}</div>
                {
                    this.generateInputFieldByType()
                }
            </div>
        )
    }
}
